<template>
    <div v-if="config.display" v-show="!config.hideControl" :style="{'width': config.width || '100%'}" class="control e-control">
        <label-wrapper :label-settings="config"></label-wrapper>
        <div v-if="asField">
            <display-value :id="config.id" :value="value"></display-value>
        </div>
        <div v-else>
            <div v-if="!optionsReady" class="loading-message">
                Getting data. Please wait...
            </div>
            <div v-else>
                <div :class="{'ec-icon-picker': config.isEc}">
                    <div>
                        <ejs-dropdownlist
                            v-bind="syncfusionConfig"
                            v-model="value"
                            :value="value"
                            :allowFiltering="true"
                            :dataSource1="$options.icons"
                            :cssClass="'icon-picker-dd'"
                            :fields="{ text: 'text', value: 'value' }"
                            :readonly="config.readonly || config.disabled"
                            :floatLabelType="config.floatLabelType || 'Never'"
                            :placeholder="ddStoreFilter(config.placeholder)"
                            v-on:click="action($event, 'onclick')"
                            v-on:focus="action($event, 'onfocus')"
                            v-on:change="action($event, 'onchange', config)"
                            v-on:filtering="action($event, 'onfiltering')"
                            :ref="ref"
                            :data-test-id="dataTestId"
                            :enabled="!config.disabled"
                            :showClearButton="showClearButton"
                            :itemTemplate="itemTemplate"
                            :valueTemplate="valueTemplate"
                            :noRecordsTemplate="'No icons found'"
                            :filterType="'contains'"
                            @filtering="filtering"
                            :created="ipCreated"
                        ></ejs-dropdownlist>
                    </div>
                    <div class="sub-content-area">
                        <div class="message-container" v-if="config.message">
                            <p class="input-info" v-html="ddStoreFilter(config.message)"></p>
                        </div>
                    </div>
                </div>
                <div v-show="config.isEc">
                    <span class="iconpicker" @click="openDropdown">
                        {{ !value ? '...' : ''}}
                        <i v-if="value" :class="value"><div style="display: none;">{{value}}</div></i>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { controlMixins } from "./controlMixins.js";
import iconData from "./icons.json";
import { library } from "@common/library/library";

export const iconPickerComponent = {
    data() {
        return {
            icons: [],
            filterTimeout: false
        };
    },
    mixins: [controlMixins],
    computed: {
        showClearButton() {
            return typeof this.config.showClearButton !== 'undefined' ? this.config.showClearButton : true;
        },
        itemTemplate() {
            let templateId = 'itemTemplate_' + this.config.name;

            let tmpCmp = vueApp.component(templateId, {
                template: `<div class="e-list-item-header icon-picker-list-item"><div class="icon-picker-list-item-icon" :class="data.value"></div></div>`,
                data() {
                    return {
                        config: this.config,
                        data: {}
                    };
                }
            });
            let tmpFunc = function () {
                return {
                    template: tmpCmp
                };
            };
            Object.defineProperty(tmpFunc, "name", { value: templateId });
            return tmpFunc;
        },
        valueTemplate() {
            let templateId = 'valueTemplate_' + this.config.name;

            let tmpCmp = vueApp.component(templateId, {
                template: `<div class="e-list-item-header icon-picker-list-value"><div class="icon-picker-list-value-icon" :class="data.value"></div></div>`,
                data() {
                    return {
                        config: this.config,
                        data: {}
                    };
                }
            });
            let tmpFunc = function () {
                return {
                    template: tmpCmp
                };
            };
            Object.defineProperty(tmpFunc, "name", { value: templateId });
            return tmpFunc;
        },
        ref() {
            return this.config.ref || this.config.id;
        }
    },
    created() {
        let icons = [];
        for (let i in iconData) {
            let searchTerms = library.cloneObj(iconData[i].searchTerms, true, true);
            icons.push({
                text: iconData[i].prefix + iconData[i].iconName,
                value: iconData[i].prefix + iconData[i].iconName,
                searchTerms: searchTerms || []
            });
        }
        this.$options.icons = library.cloneObj(icons);
    },
    methods: {
        ipCreated() {
            this.$refs[this.ref].setProperties({ dataSource: this.$options.icons });
        },
        filtering(e) {
            if (e.text.length && e.text.length < 3) return; // NOSONAR
            clearTimeout(this.filterTimeout);
            this.filterTimeout = setTimeout(() => {
                let result = this.$options.icons.filter((icon) => icon.text.indexOf(e.text) !== -1 || icon.searchTerms.indexOf(e.text) !== -1);
                e.updateData(result);
            }, 500); // NOSONAR
        },
        openDropdown() {
            if (typeof this?.$refs?.[this.ref]?.ej2Instances?.showPopup === 'function') {
                this?.$refs?.[this.ref]?.ej2Instances?.showPopup();
            }
        }
    },
    components: {
        'ejs-dropdownlist': defineAsyncComponent(() => import('@common/syncfusion/dropdownList'))
    }
};

export default iconPickerComponent;
</script>
<style scoped>
.sub-content-area {
    display: flex;
}
.sub-content-area > div {
    margin: 0 10px;
    position: relative;
    top: -4px;
}
.sub-content-area > div + div {
    margin-left: 0;
}
.sub-content-area > div.message-container {
    flex-grow: 9;
}
.ec-icon-picker {
    visibility: hidden;
    height: 0px;
    width: 20px;
}
</style>
<style>
.icon-picker-dd {
    min-width: 300px;
}
.icon-picker-dd .e-list-item {
    width: 48px !important;
    height: 48px !important;
    float: left !important;
    padding: 0 !important;
}
.icon-picker-list-value-icon {
    display: block !important;
    line-height: 40px !important;
    font-size: 20px !important;
}
.icon-picker-list-item-icon {
    display: block !important;
    line-height: 40px !important;
    font-size: 20px !important;
    text-indent: 0px !important;
    text-align: center !important;
}
.icon-picker-list-item-icon:before {
    text-indent: 0px !important;
}
</style>
